var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2019_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.916992 8.96361L9.48708 2.33338C10.3771 1.66752 11.6235 1.66752 12.5136 2.33338L21.0837 8.96361M3.60588 6.88336V17.7966C3.60588 19.1059 4.70942 20.1673 6.0707 20.1673H7.3031H14.6975H15.93C17.2912 20.1673 18.3948 19.1059 18.3948 17.7966V6.88336M8.53551 20.1673V13.0551C8.53551 12.4004 9.08728 11.8697 9.76792 11.8697H12.2327C12.9134 11.8697 13.4651 12.4004 13.4651 13.0551V20.1673",
    stroke: "#2828F0",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2019_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageOverviewIcon);
export default __webpack_public_path__ + "static/media/pageOverviewIcon.57a40bf2ecc257c7ccca46f4198063db.svg";
export { ForwardRef as ReactComponent };